import { Box, Typography } from "@mui/material";

import { LoginForm } from "./components/LoginForm";

export function LoginPage() {
  return (
    <>
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        gap={1.5}
        sx={{ mb: 5 }}
      >
        <Typography variant="h5">Přihlášení</Typography>
      </Box>
      <LoginForm />
    </>
  );
}
